export default function () {
  return {
    localContents: [],
  }
}
